import locale from "localization";

export const deliveryLogRecipient = ["Station"];

export const productTypeOption = [
  { label: locale.fuel, value: "fuel" },
  { label: locale.lubricants, value: "lubricant" },
];
